<template>

    <m-edit1/>

    <m-search-1 v-bind='{...{"offerType":"number","offerStatus":true,"productCardName":"mProductCard309"},...{}}' :style='"padding-top:100px"' class="" ></m-search-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSearch1 from '@moeinmdn/miw-alpha-components/src/package/Search/Single/Search1/Search1';

export default {
    name: 'HomeView',
    components: {mEdit1, mSearch1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
